import type { i18n as I18n } from 'i18next';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

/**
 * Supplies the page's i18next instance. The locale is fixed per page load by
 * its URL (switching language is a navigation), and `<html lang>` is written
 * by the document itself, so nothing here needs to react to changes.
 */
export const I18nProvider = ({ i18n, children }: { i18n: I18n; children: ReactNode }) => (
  <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
);
